import React from "react";
import "../../../styles/styles.css";
import "../../../../../styles/global.css";
import { useTheme } from "../../../../../utils/ThemeContext";

const ProfileLink = ({ isActive, src, text, src_dark, value, handleClick }) => {
  const { theme } = useTheme();
  return (
    <div
      onClick={() => handleClick(value)}
      className={`flex-direction-row items-center pointer profile-link ${
        isActive ? "active" : ""
      }`}
    >
      <img
        src={theme === "light" ? src : src_dark}
        width={24}
        height={24}
        alt="icon"
      />
      <p className="inria-sans-300 font-14 weight-700 profile-term">{text}</p>
    </div>
  );
};
export default ProfileLink;
